
import { defineComponent } from 'vue'
// import IGuideDto from '@/interfaces/IGuideDto'

export default defineComponent({
	name: 'PageView',
	components: {
	},
	props: ["categoriesprop"],
	// data() { return {
	// 	searchText: '' as string,
	// 	foundGuides: [] as IGuideDto[]
	// }},
	computed: {
		showBurger() {
			if(window.innerWidth < 1400) {
				return true
			}
			return false
		}
	},
	// watch: {
	// 	searchText: {
	// 		handler(val) {
	// 			if(typeof val === 'string' && val.length > 2) {
	// 				let foundGuides = [] as IGuideDto[]
	// 				this.categoriesprop.forEach((topcategory: any) => {
	// 					topcategory.guides.forEach((topguide: IGuideDto) => {
	// 						if(topguide.name.includes(val)) {
	// 							foundGuides.push(topguide)
	// 						}
	// 					})
	// 					topcategory.children.forEach((lowercategory: any) => {
	// 						lowercategory.guides.forEach((lowerguide: IGuideDto) => {
	// 							if(lowerguide.name.includes(val)) {
	// 								foundGuides.push(lowerguide)
	// 							}
	// 						})
	// 					})
	// 				})
	// 				this.foundGuides = foundGuides;
	// 				return;
	// 			}
	// 		}
	// 	}
	// }
})
